export const snapSla = (lead) => {
  if (!lead?.snapped_at || lead.snap_attended) return null;
  const hours = (Date.now() - new Date(lead.snapped_at).getTime()) / 3600000;
  if (hours <= 24) return { level: "green", hours, color: "#10B981", anim: "animate-flash", label: "Attend within 24h" };
  if (hours <= 72) return { level: "yellow", hours, color: "#F59E0B", anim: "animate-flash", label: "Overdue 24–72h" };
  return { level: "red", hours, color: "#EF4444", anim: "animate-blink", label: "Unattended >72h" };
};

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "";

// Age of a lead since it entered the platform (created_at): green flash <24h, yellow 24–72h, red flash >72h.
export const ageSla = (lead) => {
  if (!lead?.created_at) return null;
  const hours = (Date.now() - new Date(lead.created_at).getTime()) / 3600000;
  if (hours < 24) return { level: "green", hours, color: "#10B981", anim: "animate-flash", label: "Added less than 24h ago" };
  if (hours <= 72) return { level: "yellow", hours, color: "#F59E0B", anim: "", label: "In platform 24–72h" };
  return { level: "red", hours, color: "#EF4444", anim: "animate-blink", label: "In platform more than 72h" };
};
